import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// ASSETS
import ReasonDesktopBg from '@/assets/images/home/reason-desktop-bg.svg';
import ReasonMobileBg from '@/assets/images/home/reason-mobile-bg.svg';
import CutLinePic from '@/assets/images/home/cut-line.svg';

export const ReasonContainer = styled.section`
  position: relative;
  background-image: url(${ReasonDesktopBg});
  background-position: left center;
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 95px;
  padding-bottom: 75px;
  z-index: 100;
  background-color: ${WHITE};

  ${breakpoints.down('sm')} {
    background-image: url(${ReasonMobileBg});
    background-position: left top;
    background-repeat: no-repeat;
    background-size: auto;
  }

  ${breakpoints.down('xs')} {
    padding-bottom: 45px;
  }

  .reason {
    &__title {
      max-width: 350px;

      ${breakpoints.down('sm')} {
        font-size: 4.6rem;
        line-height: 5rem;
        text-align: center;
        max-width: 100%;
        margin-bottom: 35px;
      }

      .cut-line {
        position: relative;

        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-image: url(${CutLinePic});
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }
  }
`;

export default ReasonContainer;
